export class OnTimeRequestFactor {
    onTimeRequestFactorId: number;
    factorSetId: number;
    
    onTimePercent: number;
    onTimeAmountPercent: number;
}